/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import {Component, OnInit} from '@angular/core';
import {environment} from '../environments/environment';
import { NbIconLibraries } from '@nebular/theme';

@Component({
  selector: 'ngx-app',
  template: `
    <div id="mode-maintenance" *ngIf="modeMaintenance"><p class="mb-0">Estamos en mantenimiento</p></div>
    <router-outlet></router-outlet>`,
})
export class AppComponent implements OnInit {
  modeMaintenance = false

  constructor(private iconLibraries: NbIconLibraries) {
    this.iconLibraries.registerFontPack('eva', { packClass: 'eva', iconClassPrefix: 'eva' });
    this.iconLibraries.setDefaultPack('eva'); // Sets 'eva' as the default pack
  }

  ngOnInit(): void {
    this.modeMaintenance = environment.modeMaintenance
  }
}
